import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CustomFilter } from 'app/ComponentLibrary/Filter/CustomFilter';
import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import { passportCredSearchFilterName } from './PassportCredFilterUtility';
import { gridStateActions } from 'app/components/Common/Grid/GridStateManagement/GridState.redux';
import { useFormContext } from 'react-hook-form';
import { defaultPassportCredFilters } from './IPassportCredFilter';
import { useParams } from 'react-router-dom';
import { selectMiscellaneousPlacementData } from '../../../../../../../store/redux-store/placement-details/selectors';
import _ from 'lodash';
import { placementDetailsAction } from '../../../../../../../store/redux-store/placement-details/slice';

interface RouteParams {
  placementId: string;
}

export const PassportCredSearchFilters = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { defaultValues } = props;
  const { setValue, reset } = useFormContext();
  const params = useParams<RouteParams>();
  const { passportChecklist } = useSelector(selectMiscellaneousPlacementData);
  const [fields, setFields] = useState<any[]>([]);

  const resetFilter = () => {
    Object.entries(defaultValues).map(item => setValue(item[0], item[1]));
    dispatch(
      gridStateActions.setFilterAttributes({
        filterObject: Object.entries(defaultValues),
        selectedChipFilters: { ...defaultPassportCredFilters },
      }),
    );
    reset(defaultPassportCredFilters);
    props.handleReset();
  };

  useEffect(() => {
    if (passportChecklist) {
      //Extract Category
      const categoryList = passportChecklist?.map(d => {
        return { id: d.categoryId, name: d.category, value: d.categoryId };
      });

      const statusList = [
        { id: 1, name: 'Compliant', value: 1 },
        { id: 2, name: 'Not Compliant', value: 2 },
      ];
      setFields(
        getPassportCredFilterSpecs({
          status: _.uniqBy(statusList, 'id'),
          category: _.uniqBy(categoryList, 'id'),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passportChecklist]);

  const getPassportCredFilterSpecs = filterSpecs => [
    {
      filterName: t('placement.profile.tabs.passportCredSearchFilters.status'),
      name: passportCredSearchFilterName.status,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      isMultiSelect: true,
      options: filterSpecs.status,
      placeholder: t('placement.profile.tabs.passportCredSearchFilters.placeholder'),
      version2: true,
      returnsObjectAsValue: true,
      size: 'large',
    },
    {
      filterName: t('placement.profile.tabs.passportCredSearchFilters.category'),
      name: passportCredSearchFilterName.category,
      type: FilterCompTypes.TYPEAHEADDROPDOWN,
      isMultiSelect: true,
      options: filterSpecs.category,
      placeholder: t('placement.profile.tabs.passportCredSearchFilters.placeholder'),
      version2: true,
      returnsObjectAsValue: true,
      size: 'large',
      selectAllValue: 'All',
    },
  ];

  useEffect(() => {
    dispatch(placementDetailsAction.getPassportChecklist({ placementId: parseInt(params.placementId) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      {props.isEnabled && (
        <>
          <CustomFilter fields={fields} justifyContent={'flex-start'} version2 onResetForm={() => resetFilter()} />
        </>
      )}
    </React.Fragment>
  );
};
